import React, { useState } from 'react';
import { FaUser, FaLock, FaEye, FaEyeSlash } from 'react-icons/fa';
import '../css/auth/LoginPage.css';
import { config } from '../utils/config';

const LoginPage = ({ onLogin }) => {
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials(prev => ({
      ...prev,
      [name]: value
    }));
    if (error) setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Real API call to login endpoint
      const response = await fetch(`${config.API_BASE_URL}/kirazee/api/v1/admin/auth/login/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          login_identifier: credentials.username,
          password: credentials.password
        })
      });

      const data = await response.json();

      if (data.success) {
        const loginData = data.data || {};
        const userData = {
          id: loginData.staff_id || credentials.username,
          login_identifier: credentials.username,
          username: loginData.username || credentials.username,
          name: loginData.username || 'Administrator',
          role: loginData.role || 'SuperAdmin',
          token: loginData.token,
          user_id: loginData.user_id,
          user_mode: 'admin',
          navigation_items: loginData.navigation_items || []
        };

        localStorage.setItem('user', JSON.stringify(userData));
        if (loginData.token) {
          localStorage.setItem('authToken', loginData.token);
          // Also set it in sessionStorage for safeStorage compatibility in some utils
          sessionStorage.setItem('authToken', loginData.token);
        }

        onLogin(userData);
      } else {
        // Handle structured error messages
        let errorMessage = data.message || 'Login failed';

        // If there are specific field errors, show them
        if (data.errors) {
          const errorMessages = [];
          Object.keys(data.errors).forEach(field => {
            if (data.errors[field] && data.errors[field].length > 0) {
              errorMessages.push(`${field}: ${data.errors[field].join(', ')}`);
            }
          });

          if (errorMessages.length > 0) {
            errorMessage = errorMessages.join('\n');
          }
        }

        setError(errorMessage);
      }
    } catch (err) {
      console.error('Login error:', err);
      setError(err.message || 'Login failed. Please check your connection and try again.');
    } finally {
      setLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="login-container">
      <div className="login-background">
        <div className="login-overlay"></div>
      </div>

      <div className="login-card">
        <div className="login-header">
          <div className="login-logo">
            <div className="logo-icon">
              <FaUser />
            </div>
            <h1>Kirazee</h1>
          </div>
          <h2>Admin Portal</h2>
          <p>Sign in to access your dashboard</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {error && (
            <div className="error-message">
              {error.split('\n').map((line, index) => (
                <div key={index}>{line}</div>
              ))}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="username">Username</label>
            <div className="input-wrapper">
              <input
                type="text"
                id="username"
                name="username"
                value={credentials.username}
                onChange={handleChange}
                placeholder="Enter your username"
                required
                disabled={loading}
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <div className="input-wrapper">
              <input
                type={showPassword ? 'text' : 'password'}
                id="password"
                name="password"
                value={credentials.password}
                onChange={handleChange}
                placeholder="Enter your password"
                required
                disabled={loading}
              />
              <button
                type="button"
                className="password-toggle"
                onClick={togglePasswordVisibility}
                disabled={loading}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>

          <button
            type="submit"
            className={`login-button ${loading ? 'loading' : ''}`}
            disabled={loading}
          >
            {loading ? '' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;